module.exports = __webpack_public_path__ + "img/icon_user_fuwuqiye.d73477a4.png";